/**
 * As a temporary measure, we're mapping ID of the question to a category
 *
 * wet groupings:
 * Green Culture & Team Communication
 * Lab Waste Management
 * Cold Storage
 * Computer Energy Usage
 *
 * dry groupings:
 * Green Culture & Team Communication
 * Eco-Office
 * Data Storage
 * Computer Energy Use
 *
 */

export const TemporaryQuestionIdToCategoryMapping: Record<number, string> = {
  // Wet - Normal User
  1: "Green Culture & Team Communication",
  2: "Green Culture & Team Communication",
  3: "Green Culture & Team Communication",
  127: "Green Culture & Team Communication",
  4: "Lab Waste Management",
  5: "Lab Waste Management",
  6: "Lab Waste Management",
  7: "Lab Waste Management",
  8: "Cold Storage",
  9: "Cold Storage",
  10: "Cold Storage",
  11: "Cold Storage",
  12: "Cold Storage",
  13: "Computer Energy Usage",
  14: "Computer Energy Usage",
  15: "Computer Energy Usage",
  16: "Computer Energy Usage",
  17: "Computer Energy Usage",
  // Wet - Auditor
  18: "Green Culture & Team Communication",
  19: "Green Culture & Team Communication",
  20: "Green Culture & Team Communication",
  131: "Green Culture & Team Communication",
  21: "Lab Waste Management",
  22: "Lab Waste Management",
  23: "Lab Waste Management",
  24: "Lab Waste Management",
  25: "Cold Storage",
  26: "Cold Storage",
  27: "Cold Storage",
  28: "Cold Storage",
  29: "Cold Storage",
  30: "Cold Storage",
  31: "Computer Energy Usage",
  32: "Computer Energy Usage",
  33: "Computer Energy Usage",
  34: "Computer Energy Usage",

  // Dry - Normal User
  35: "Green Culture & Team Communication",
  36: "Green Culture & Team Communication",
  37: "Green Culture & Team Communication",
  128: "Green Culture & Team Communication",
  129: "Eco-Office",
  39: "Eco-Office",
  40: "Eco-Office",
  44: "Eco-Office",
  130: "Eco-Office",
  46: "Computer Energy Usage",
  47: "Computer Energy Usage",
  48: "Computer Energy Usage",
  49: "Computer Energy Usage",
  50: "Computer Energy Usage",
  41: "Data Storage",
  42: "Data Storage",
  43: "Data Storage",
  45: "Data Storage",
  // Dry - Auditor
  55: "Green Culture & Team Communication",
  56: "Green Culture & Team Communication",
  57: "Green Culture & Team Communication",
  58: "Eco-Office",
  59: "Eco-Office",
  60: "Eco-Office",
  61: "Eco-Office",
  62: "Data Storage",
  63: "Eco-Office",
  64: "Data Storage",
  65: "Data Storage",
  66: "Data Storage",
  // NOTE: ids 67-72 were previously (incorrectly) listed here as bronze Dry-Auditor
  // "Computer Energy Usage". Verified against the DB (l0.checklist_questions) that
  // 67-84 are actually the SILVER Wet lab questions — corrected in the silver block below.

  // Silver - Wet - Normal User (issue #326).
  // IDs verified live: SELECT id, question FROM l0.checklist_questions
  //   WHERE level='silver' AND lab_type='wet' AND for_auditor=false ORDER BY id.
  // Category keys must match ORDERED_WET_CATEGORIES_SILVER + CategoryToResourceMapping.silver.
  67: "Procurement", // single-use item
  68: "Procurement", // bulk purchasing
  69: "Procurement", // order schedules
  70: "Procurement", // surplus stock
  71: "Procurement", // recycled/biodegradable
  72: "Procurement", // Emissions resource
  73: "Procurement", // supplier sustainability strategy
  74: "Green Chemistry", // re-use containers
  75: "Green Chemistry", // 12 Principles resource
  76: "Green Chemistry", // safer solvent alternative
  77: "Green Chemistry", // chemical labels (GHS)
  78: "Green Chemistry", // bio-based chemical
  79: "Green Chemistry", // chemical exchange shelf
  80: "Procurement", // take-back programs
  81: "Procurement", // avoid express shipping
  82: "Sustainable Transport", // one commute a month
  83: "Sustainable Transport", // Green Transport guide
  84: "Sustainable Transport", // shared transport example
};
